<template>
  <div>
    <div v-if="!success">
      <div class="row">
        <div class="col">
          <Input
            label="Código de funcionário"
            placeholder="ex.: 589254786"
            v-model="code"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Input
            label="Nome completo"
            placeholder="ex.: João da Silva"
            v-model="name"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label>
            <StrongText>Gênero</StrongText>
          </label>
          <div class="group">
            <radio-button label="Feminino" value="Feminino" v-model="gender" />
            <radio-button label="Masculino" value="Masculino" v-model="gender" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg">
          <Input
            label="Email"
            placeholder="ex.: joao@site.com"
            v-model="email"
          />
        </div>
        <div class="col-12 col-lg">
          <Input
            label="Data de nascimento"
            placeholder="ex.: 10/04/1981"
            type="tel"
            v-mask="'##/##/####'"
            v-model="birth"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label>
            <StrongText>Tamanho da camiseta</StrongText>
          </label>
          <div class="group">
            <radio-button label="P" value="P" v-model="size" />
            <radio-button label="M" value="M" v-model="size" />
            <radio-button label="G" value="G" v-model="size" />
            <radio-button label="GG" value="GG" v-model="size" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Input
            label="Celular para receber mensagem (Whatsapp)"
            placeholder="ex.: 11 98765 4321"
            type="tel"
            v-mask="['(##) #### ####', '(##) ##### ####']"
            v-model="phone"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Input
            label="Telefone de Emergência"
            placeholder="ex.: 11 98765 4321"
            type="tel"
            v-mask="['(##) #### ####', '(##) ##### ####']"
            v-model="emergency"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Input
            label="Se for de carro ao evento, informe a placa do veículo"
            placeholder="ex.: ELV 1555"
            v-mask="'AAA-####'"
            v-model="car"
          />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label>
            <StrongText>Confirmação da leitura do regulamento:</StrongText>
          </label>
          <div class="group">
            <radio-button label="Li e aceito o regulamento" :value="true" v-model="regulamento" />
          </div>
        </div>
      </div>
    </div>
    <div class="row text-center">
      <div class="col">
        <span @click="send">
          <Button big :disabled="disabled">Cadastrar</Button>
        </span>
      </div>
    </div>
    <div class="row" v-if="error || success">
      <div class="col">
        <br/>
        <Alert
          error
          v-if="error"
          v-html="error"
        />
        <Alert
          success
          v-if="success"
          v-html="success"
        />
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api'
import Alert from '@/components/Alert'
import Check from '@/components/Check'
import CheckGender from '@/components/CheckGender'
import Input from '@/components/Input'
import Button from '@/components/Button'
import StrongText from '@/components/StrongText'

import RadioButton from '@/components/RadioButton'

export default {
  name: 'CaminhadaInscrevase',
  data: () => ({
    code: '',
    name: '',
    email: '',
    birth: '',
    size: '',
    phone: '',
    emergency: '',
    gender: '',
    car: '',
    disabled: false,
    error: false,
    success: false,
    regulamento: false,
  }),
  methods: {
    async send() {

      if(this.disabled)
        return

      this.error = false
      this.success = false
      this.disabled = true

      try {

        let str = this.birth.split('/')

        await api.walk({
          code: this.code,
          name: this.name,
          email: this.email,
          birth: `${str[2]}-${str[1]}-${str[0]}`,
          size: this.size,
          phone: this.phone,
          emergency: this.emergency,
          gender: this.gender,
          car: this.car,
          regulamento: this.regulamento,
        })

        this.code = ''
        this.name = ''
        this.email = ''
        this.birth = ''
        this.size = ''
        this.phone = ''
        this.emergency = ''
        this.gender = ''
        this.car = ''

        this.success = 'Cadastro realizado com sucesso! Esperamos você no evento'

      } catch (response) {

        const error = Object.values(response.response.data.errors)
        this.error = error[0][0]
        setTimeout(() => this.disabled = false, 1000)

      }
    },
  },
  components: {
    CheckGender,
    Input,
    Check,
    Alert,
    Button,
    StrongText,
    RadioButton
  }
}
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center
}
.group {
  margin-top: 11px;
  margin-bottom: 60px;
}
</style>
